import { c as _c } from "react-compiler-runtime";
import { useMemo } from 'react';
import { useExpandableObjectIdsStore } from 'framework-listing-lib/internal/providers/CrmObjectTypeListingClientProvider';

/**
 * This hook is meant to be used by host apps.
 * Exposing a getter and setter for expandable row objects
 */
export default function useExpandCollapseRow() {
  "use memo";

  const $ = _c(7);
  const expandedObjectIds = useExpandableObjectIdsStore(_temp);
  let t0;
  if ($[0] !== expandedObjectIds) {
    t0 = Array.from(expandedObjectIds);
    $[0] = expandedObjectIds;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const expandableObjectIdsArray = t0;
  const collapseAll = useExpandableObjectIdsStore(_temp2);
  const expandRow = useExpandableObjectIdsStore(_temp3);
  const collapseRow = useExpandableObjectIdsStore(_temp4);
  let t1;
  if ($[2] !== collapseAll || $[3] !== collapseRow || $[4] !== expandRow || $[5] !== expandableObjectIdsArray) {
    t1 = {
      collapseAll,
      collapseRow,
      expandableObjectIds: expandableObjectIdsArray,
      expandRow
    };
    $[2] = collapseAll;
    $[3] = collapseRow;
    $[4] = expandRow;
    $[5] = expandableObjectIdsArray;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
}
function _temp4(store_2) {
  return store_2.collapseRow;
}
function _temp3(store_1) {
  return store_1.expandRow;
}
function _temp2(store_0) {
  return store_0.collapseAll;
}
function _temp(store) {
  return store.expandedObjectIds;
}